export const PROMPT_ACTION_FORM = {
  NOTIFICATIONS: {
    TITLE: "Show notifications?",
    BODY: "To be notified on views, select 'YES' and 'Allow' when prompted for notifications"
  }
};